import { ajv as a, schema as s, uiSchema as u } from './schema.js';

export const version = 1.0;
export const ajv = a;
export const schema = s;
export const uiSchema = u;